import { render, staticRenderFns } from "./iconBtnGroup.vue?vue&type=template&id=1fa5b258&"
import script from "./iconBtnGroup.vue?vue&type=script&lang=js&"
export * from "./iconBtnGroup.vue?vue&type=script&lang=js&"
import style0 from "./iconBtnGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "iconBtnGroup.vue"
export default component.exports